import { createCloudRunAxios } from './axios';

const remiApi = createCloudRunAxios('remi-api');

export interface StartContactDispatchInput {
  contactId: string;
  idempotencyKey?: string;
}

export interface StartContactDispatchResponse {
  success: boolean;
  dispatch_id: string;
  status: string;
  message: string;
  contact_id: string;
  organization_id: string;
  contact_name?: string | null;
  agent_call_sid?: string | null;
  reused?: boolean;
}

export const startContactDispatch = async (
  input: StartContactDispatchInput
): Promise<StartContactDispatchResponse> => {
  const response = await remiApi.post<StartContactDispatchResponse>('/api/v1/dispatches/contact-call', {
    contactId: input.contactId,
    idempotencyKey: input.idempotencyKey,
  });
  return response.data;
};
